import { AnaColumn } from "../forms-template.service";





export const crmTagsGrid: AnaColumn[] = [
  {
    configuration: {
      service: 'crmTagsForm',
      widthForm: 500,
      heightForm: 200,
      api: 'tabella',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      isPopUp: true,

      nCol: 1,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: [

      {
        type: 'campo',
        dataField: 'id',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Codice',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'descrizione',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Descrizione',
        colAlignment: 'start',
        showClearButton: true,
        maxLength: 255,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]

      },
      {
        type: 'campo',
        dataField: 'tipo',
        colVisible: true,
        visible: true,
        dataType: '',
        caption: 'Tipo',
        colWidth: 200,
        width: 200,

        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ],
        //per lista static in griglia devi inserire i valori da leggere in form template e ritornarli in getDati 
        lista: {
          dataSource: 'tipoTab',
          queryString: '',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          wingap: false,
        }
      },
      /*       {
              type: 'campoSpecial', dataField: "descrizione",
              colVisible: true, dataType: "",
              caption: "Descrizione Tag",
              editorClass: '',
              disableOnUpdate: false,
              dynamic: {
                dataSource: 'tabella',
                displayExpr: 'descrizione',
                valueExpr: '',
                autocomplete: false,
                related: ['id|id'],
                caption: "Lista tag statistiche",
                queryString: '?tipo=3',
                filter: '',
                componentType: 'dynamicGrid',
      
                buttonOption: {
                  text: 'Abbina posizioni',
                  icon: 'glyphicon mdi mdi-playlist-plus',
                  hint: 'Sfoglia tag statistiche',
                  name: 'listTagStatistiche',
                  location: 'after',
      
                },
                settingGrid: {
                  campoTabRif: '', // in questo caso lo lascio vuoto in quanto la griglia non deve effettuare operazioni salvataggio
                  masterKey: 'id',
                  keyUnique: 'id',
                  selectionMode: 'single',
                  rowAlternationEnabled: true,
                  repaintChangesOnly: false,
                  remoteOperations: true,
                  hoverStateEnabled: true,
                  wingap: false,
                  allowUpdating: false,
                  allowDeleting: false,
                  allowAdding: false,
                  searchAndSelect: false, //Cerca Valore e seleziona
                  searchAndSelectDataSource: '',
                  height: 670,
                  showColBlank: false,
                  colonne: [
                    {
                      dataField: 'id',
                      dataType: '',
                      caption: 'Codice',
                      width: 70,
                      hideOnEdit: true,
                      colVisible: false,
      
                    },
      
                    {
                      dataField: 'descrizione',
                      dataType: '',
                      caption: 'Descrizione',
      
                      hideOnEdit: false
                    },
      
      
                  ]
      
                }
      
              },
      
            }, */
    ]
  }
]
export const crmTagsForm: AnaColumn[] = [
  {
    /* configuration: {}, */
    itemType: "group", colCount: "1", class: "", caption: "Aggiungi Tag",
    data: [

      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'descrizione',
        colVisible: true,
        visible: true,
        dataType: 'string',
        editorType: 'dxTextArea',
        height: 255,
        caption: 'Descrizione',
        colAlignment: 'start',
        maxLength: 2
      },
      {
        type: 'campo',
        dataField: 'tipo',
        colVisible: true,
        visible: true,
        dataType: '',
        caption: 'Tipo',
        editorType: 'dxSelectBox',
        //per lista static in griglia devi inserire i valori da leggere in form template e ritornarli in getDati 
        lista: {
          dataSource: 'tipoTab',
          queryString: '',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: false,
          wingap: false,

        }
      },
    ]
  }
]

export const crmComuniGrid: AnaColumn[] = [
  {
    configuration: {
      service: 'crmComuniForm',
      widthForm: 500,
      heightForm: 200,
      api: 'tabella',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      isPopUp: true,
      nCol: 1,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: [
      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'codice_istat',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Codice istat',
        colAlignment: 'center',
        colWidth: 120,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
      },
      {
        type: 'campo',
        dataField: 'nome',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Comune',
        colAlignment: 'left',
        colWidth: 400,
        width: 400,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
      },
      {
        type: 'campo',
        dataField: 'id_provincia',
        colVisible: true,
        visible: true,
        dataType: '',
        caption: 'Provincia',
        colWidth: 400,
        width: 400,
        colAlignment: 'left',
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ],
        lista: {
          dataSource: 'province',
          queryString: '',
          valueExpr: 'id',
          displayExpr: 'nome',
          static: false,
          wingap: false,
        }
      },
      {
        type: 'campo',
        dataField: 'id_regione',
        colVisible: true,
        visible: true,
        dataType: '',
        caption: 'Regione',
        colAlignment: 'left',
        colWidth: 400,
        width: 400,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ],
        lista: {
          dataSource: 'regioni',
          queryString: '',
          valueExpr: 'id',
          displayExpr: 'nome',
          static: false,
          wingap: false,
        }
      },
      {
        type: 'campo',
        dataField: 'codice_catastale',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Codice catastale',
        colAlignment: 'center',
        colWidth: 120,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
      },
      {
        type: 'campo',
        dataField: 'cap',
        colVisible: true,
        visible: true,
        dataType: 'string',
        caption: 'Cap',
        colAlignment: 'center',
        colWidth: 90,
        maxLength: 5,
        validation: [
          { type: 'required', message: 'Campo obbligatorio' }
        ]
      },
    ]
  }
]
export const crmComuniForm: AnaColumn[] = [
  {
    configuration: {
      service: 'crmComuniForm',
      widthForm: 500,
      heightForm: 200,
      api: 'comuni',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      isPopUp: true,

      nCol: 1,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: []
  }
]
export const crmTagContattoStatisticheGrid: AnaColumn[] = [
  {
    configuration: {
      service: 'crmTagContattoStatisticheGrid',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      api: '',
      api_rest: true,
      remoteOperation: false,
      isEdit: false,
      nCol: 1,
      heightForm: 400,
      widthForm: 900,
      toolbarTop: false,
      toolbarBottom: true,
      isPopUp: true,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: [

      {
        type: 'campo',
        dataField: 'id_tag',
        colVisible: true,
        visible: false,
        dataType: '',
        caption: 'Descrizione Tag Tipo',
        colAlignment: 'start',
        editorType: 'dxSelectBox',
        sortOrder: 'desc',
        validation: [{ type: 'required', message: 'Campo Descrizione Tag obbligatorio' }],
        lista: {
          Async: true,
          dataSource: "tabella",
          queryString: "?tipo=1",
          //filter: "?tipo=1",
          valueExpr: 'id', displayExpr: 'descrizione',
          // queryString:'?idSede=$idDestinatario',
          showClearButton: false,
          costantValues: [
            { key: 'tipo', value: 1 }
          ]
        }
      },

    ]
  }
]

export const crmTagContattoCommercialiGrid: AnaColumn[] = [
  {
    configuration: {
      service: 'crmTagContattoCommercialiGrid',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      api: '',
      api_rest: true,
      remoteOperation: false,
      isEdit: false,
      nCol: 1,
      heightForm: 400,
      widthForm: 900,
      toolbarTop: false,
      toolbarBottom: true,
      isPopUp: true,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: [
      {
        type: 'campoSpecial', dataField: "id_tag",
        colVisible: true, dataType: "",
        caption: "Descrizione Tag",
        editorClass: '',
        disableOnUpdate: false,
        validation: [{ type: 'required', message: 'Campo Descrizione Tag obbligatorio' }],
        editorType: 'dxSelectBox',
        lista: {
          dataSource: "tabella",
          queryString: "?tipo=2",
          valueExpr: 'id', displayExpr: 'descrizione',
          // related: ['id|id'],
          showClearButton: false,
          costantValues: [
            { key: 'tipo', value: 2 }
          ]
        }
      },
    ]
  }
]

export const crmTagContattoEconomiciGrid: AnaColumn[] = [
  {
    configuration: {
      service: 'crmTagContattoEconomiciGrid',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      api: '',
      api_rest: true,
      remoteOperation: false,
      isEdit: false,
      nCol: 1,
      heightForm: 400,
      widthForm: 900,
      toolbarTop: false,
      toolbarBottom: true,
      isPopUp: true,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: [

      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice',
        colAlignment: 'center'
      },
      {
        type: 'campo', dataField: "id_tag",
        colVisible: true, dataType: "string",
        caption: "Descrizione Tag",
        editorClass: '',
        disableOnUpdate: false,
        editorType: 'dxSelectBox',
        validation: [{ type: 'required', message: 'Campo Descrizione Tag obbligatorio' }],
        lista: {
          dataSource: "tabella",
          queryString: "?tipo=3",
          valueExpr: 'id', displayExpr: 'descrizione',
          static: false,
          showClearButton: false,
          costantValues: [
            { key: 'tipo', value: 3 }
          ]
          //related:['id|id_tag']
        }
      },
    ]
  }
]


export const crmTagTipoContattoGrid: AnaColumn[] = [
  {
    configuration: {
      service: 'crmTagTipoContattoGrid',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'id',
      api: '',
      api_rest: true,
      remoteOperation: false,
      isEdit: false,
      nCol: 1,
      heightForm: 400,
      widthForm: 900,
      toolbarTop: false,
      toolbarBottom: true,
      isPopUp: true,
    },
    itemType: "group", colCount: "1", class: "", caption: "",
    data: [

      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        visible: false,
        dataType: 'string',
        caption: 'Codice Contratto',
        colAlignment: 'center'
      },
      {
        type: 'campo', dataField: "id_tag",
        colVisible: true, dataType: "",
        caption: "Descrizione Contratto",
        editorClass: '',
        disableOnUpdate: false,
        editorType: 'dxSelectBox',
        validation: [{ type: 'required', message: 'Campo Descrizione Contratto obbligatorio' }],
        lista: {
          Async: true,
          dataSource: "tabella",
          queryString: "?tipo=24",
          valueExpr: 'id', displayExpr: 'descrizione',
          static: false,
          showClearButton: false,
          costantValues: [
            { key: 'tipo', value: 24 }
          ]
          //related:['id|id_tag']
        }
      },
    ]
  }
]